import React, { Component } from 'react';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import __ from 'lodash';
import { Container, Card, Button, Fade, Row, Col, Alert, Form } from 'react-bootstrap';
import Switch from '@material-ui/core/Switch';
import LoaderModal from '../../../modal/LoaderModal';
import Loader from '../../../Loader';
import DropdownUploadHistory from '../masterDropDown/DropdownUploadHistory';
import FilterSoal from '../../../../entity/FilterSoal';
import LearningContentReq from '../../../../entity/LearningContentReq'
import history from '../../../../history';

class SoalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'soal',
            action: 'add',
            isFetching: false,
            isLoading: false,
            alertShow: false,
            resMessage: '',
            openFilter: false,
            filterPrime: false,
            filterSekolah: false,
            data: props.location.state,
            soals: [],
            soalSelected: [],
            tematik: [],
            subTematik: [],
            pembTematik: [],
            judulLearning: ''
        };
    }

    async componentDidMount() {
        document.title = "Soal Learning";
        this.setState({
            isFetching: true
        });

        this.fetchUploadHis();
        if(this.props.location.state.idProfil !== null) {
            this.getSoalSelected(this.props.location.state.idProfil);

            this.setState({
                judulLearning: this.props.location.state.judul
            })

            this.setState({
                action: 'edit'
            })
        }
        // this.fetchExamSoal(this.state.id);

        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://s3edubucket.s3-ap-southeast-1.amazonaws.com/javascripts/MathJax-2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";
            var config = 'MathJax.Hub.Config({' +
                'extensions: ["tex2jax.js"],' +
                'jax: ["input/TeX","output/HTML-CSS"]' +
                '});' +
                'MathJax.Hub.Startup.onload();';

            if (window.opera) {
                script.innerHTML = config
            }
            else {
                script.text = config
            }

            script.addEventListener('load', function() {
                window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);
            })

            document.getElementsByTagName("head")[0].appendChild(script);
        })();
        console.timeEnd('SoalForm time');
    }

    async fetchUploadHis() {
        this.setState({
            isFetching: true
        });

        const result = await accountManagement.get(CONFIG.SOAL_GET_UPLOAD_HISTORY)
        .catch(function(error) {
            console.error(error);
        });

        if (result) {
            this.setState({ uploadHis: result.data.data });
            this.setState({ isFetching: false });
        }
    }

    async getSoalSelected(id) {
        this.setState({
            isFetching: true
        });

        const result = await accountManagement.get(CONFIG.LEARNING_GET_SOAL_PROFIL + id)
        .catch(function(error) {
            console.error(error);
        });

        if (result) {
            this.setState({ soalSelected: result.data.data });
            this.setState({ isFetching: false });
        }
    }

    renderUploadHis = () => {
        const {uploadHis} = this.state;

        if (uploadHis !== null) {
            return (
                <DropdownUploadHistory uploadHis={uploadHis} />
            )
        }
    }

    /* ADD */
    getMapel = async(idKelas, idGuru) => {
        this.setState({
            isFetching: true,
            mapel: [],
            bab: [],
            subbab: []
        });

        const resMapel = await accountManagement.get(CONFIG.GURU_GET_MAPEL_BY_KELAS, {
            params: {idKelas: (idKelas === null ? 0 : idKelas), idGuru: idGuru}
        }).catch(function(error) {
            console.error(error);
        })

        if(resMapel) {
            if(resMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    mapel: resMapel.data.data,
                    data: {...this.state.data,
                        idKelas: idKelas
                    }
                })
            }
            else {
                this.setState({
                    resMessage: resMapel.data.errorSchema.errorMessage
                })
            }

            this.setState({
                isFetching: false
            });
        }
    }

    getBab = async(id) => {
        this.setState({
            isFetching: true,
            bab: [],
            subbab: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_BAB + id)
        .catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    bab: res.data.data,
                    data: {...this.state.data,
                        idMapel: id,
                        idTematik: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getSubBab = async(id) => {
        this.setState({
            isFetching: true,
            subbab:[]
        });

        // const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_SUBBAB + id)
        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_LEARNING_GET_SUBBAB + this.state.type + '/' + id)
        .catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    subbab: res.data.data,
                    data: {...this.state.data,
                        idBab: id,
                        idSubTematik: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    renderMapel() {
        let {mapel, data} = this.state;

        if(!__.isEmpty(mapel)) {
            return mapel.map((m, indexMapel) => {
                return (
                    <option key={indexMapel} value={m.idMataPelajaran} selected={parseInt(data.idMapel) === m.idMataPelajaran}>{m.namaMataPelajaran}</option>
                )
            })
        }
    }

    renderBab() {
        let {bab, data} = this.state;

        if(!__.isEmpty(bab)) {
            return bab.map((item, indexBab) => {
                return (
                    <option key={indexBab} value={item.idBab} selected={parseInt(data.idBab) === item.idBab}>{item.namaBab}</option>
                    // <option key={indexBab} value={item.idBab} selected={data.idBab === item.idBab}>{item.namaBab}</option>
                )
            })
        }
    }

    renderSubBab() {
        let {subbab, data} = this.state;

        if(!__.isEmpty(subbab)) {
            return subbab.map((item, indexSubBab) => {
                return (
                    <option key={indexSubBab} value={item.idSubBab} selected={parseInt(data.idSubBab) === item.idSubBab}>{item.namaSubBab}</option>
                )

                /*
                if(parseInt(data.idSubBab) === item.idSubBab) {
                    return ( <option value={item.idSubBab} selected>{item.namaSubBab}</option> )
                }
                else {
                    return ( <option value={item.idSubBab} >{item.namaSubBab}</option> )
                }
                */
            })
        }
    }

    getTematik = async(id) => {
        this.setState({
            isFetching: true,
            tematik: [],
            subTematik: [],
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_TEMATIK_BY_ID_KELAS, {
            params: {idKelas: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    tematik: res.data.data,
                    data: {...this.state.data,
                        idKelas: id
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getSubTematik = async(id) => {
        this.setState({
            isFetching: true,
            subTematik: [],
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_SUBTEMA, {
            params: {idTematik: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    subTematik: res.data.data,
                    data: {...this.state.data,
                        idTematik: id,
                        idMapel: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getPembTematik = async(id) => {
        this.setState({
            isFetching: true,
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_PEMBTEMA, {
            params: {idSubTematik: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    pembTematik: res.data.data,
                    data: {...this.state.data,
                        idSubTematik: id,
                        idBab: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    mapelOnChange(e) {
        console.clear();
        let id = e.target.value;
        console.info('mapelOnChange', id);

        this.setState({
            subTematik: [],
            pembTematik: [],
            bab: [],
            subbab: []
        })

        if(id !== '') {
            this.getBab(id);
        }
    }

    babOnChange(e) {
        console.clear();
        let id = e.target.value;
        console.info('babOnChange', id);

        this.setState({
            pembTematik: [],
            subbab: []
        })

        if(id !== '') {
            this.getSubBab(id);
        }
    }

    subBabOnChange(e) {
        console.clear();
        let id = e.target.value;
        console.info('subBabOnChange', id);

        if(id !== '') {
            this.setState({
                data: {...this.state.data,
                    idSubBab: id,
                    idPembTematik: null
                }
            })
        }
    }

    getTematik = async(id) => {
        this.setState({
            isFetching: true,
            tematik: [],
            subTematik: [],
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_TEMATIK_BY_ID_KELAS, {
            params: {idKelas: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    tematik: res.data.data,
                    data: {...this.state.data,
                        idKelas: id
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getSubTematik = async(id) => {
        this.setState({
            isFetching: true,
            subTematik:[],
            pembTematik:[]
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_SUBTEMA, {
            params: {idTematik: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    subTematik: res.data.data,
                    data: {...this.state.data,
                        idTematik: id,
                        idMapel: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getPembTematik = async(id) => {
        this.setState({
            isFetching: true,
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_PEMBTEMA,
            {params: {idSubTematik: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    pembTematik: res.data.data,
                    data: {...this.state.data,
                        idSubTematik: id,
                        idBab: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }

            this.setState({
                isFetching: false
            });
        }
    }

    temaOnChange(e) {
        let id = e.target.value;
        console.info('temaOnChange', id);
        this.setState({
            subTematik: [],
            pembTematik: [],
            bab: [],
            subbab: []
        })

        if(id !== '') {
            this.getSubTematik(id);
        }
    }

    subTemaOnChange(e) {
        let id = e.target.value;
        console.info('subTemaOnChange', id);

        this.setState({
            pembTematik: [],
            subbab: []
        })

        if(id !== '') {
            this.getPembTematik(id);
        }
    }

    pembTemaOnChange(e) {
        let id = e.target.value;
        console.info('pembTemaOnChange', id);

        if(id !== '') {
            this.setState({
                data: {...this.state.data,
                    idSubBab: null,
                    idPembTematik: id
                }
            })
        }
    }
    /* ADD */

    filterSoal = () => {
        // console.clear();
        console.info('filterSoal');
        const { open, data } = this.state;
        // const {action, , kelasParalel} = this.state;

        return (
          <>
            <Row>
                <Col>
                    <h3>Learning Soal</h3>
                </Col>

                <Col>
                    <Button variant="outline-dark" style={{ width: '100%' }} onClick={() => this.setState({ open: !open , filterPrime: false, filterSekolah: true })} aria-controls="example-fade-text" aria-expanded={open}>
                        Open Soal
                    </Button>
                </Col>

                <Col>
                    <Button variant="outline-danger pull-right" onClick={() => {if (window.confirm('Konfirmasi Keluar ?')) this.handleBack() }}>
                        Keluar <i className="fa fa-arrow-right"></i>
                    </Button>
                </Col>
            </Row>

            { open ?
                <Fade in={open}>
                    <Card style={{ marginTop: '10px' }}>
                        <Card.Body>
                            <Row>
                                <div className="form-group col-sm-2">Pilih Sumber Soal :</div>
                                <div className="form-group col-sm-2">
                                    <select className="form-control" name="sumber" id="sumber" onChange={this.changeSumber} ref={this.sumber}>
                                        <option value="PSEP">Sekolah</option>
                                        <option value="PRIME">Eduprime</option>
                                    </select>
                                </div>
                            </Row>

                            { this.state.filterPrime &&
                                <>
                                    <Row>
                                        <input type="hidden" id="upload" value="0"/>
                                    </Row>

                                    <Form.Group>
                                        <>
                                            <ul className="nav nav-tabs">
                                                <li className="nav-item">
                                                    <a className="nav-link active" data-toggle="tab" href="#one">Mata Pelajaran</a>
                                                </li>

                                                <li className="nav-item">
                                                    <a className="nav-link" data-toggle="tab" href="#two">Tematik</a>
                                                </li>
                                            </ul>

                                            <div className="tab-content" style={{ marginTop: '1em' }}>
                                                <div className="tab-pane active" id="one">
                                                    <Row >
                                                        <Col>
                                                            <Form.Group controlId="mapel">
                                                                <select className="form-control" name="mapel" onChange={e => this.mapelOnChange(e)}>
                                                                    <option value="">Pilih Mata Pelajaran...</option>
                                                                    {this.renderMapel()}
                                                                </select>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col>
                                                            <Form.Group controlId="bab">
                                                                <select className="form-control" name="bab" onChange={(e) => this.babOnChange(e)}>
                                                                    <option value="">Pilih Bab...</option>
                                                                    {this.renderBab()}
                                                                </select>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col>
                                                            <Form.Group controlId="subBab">
                                                                <select className="form-control" name="subBab" onChange={(e) => this.subBabOnChange(e)}> <option value="">Pilih Sub Bab...</option>
                                                                    {this.renderSubBab()}
                                                                </select>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                <div className="tab-pane" id="two">
                                                    <Row>
                                                        <Col>
                                                            <Form.Group controlId="tema">
                                                                <select className="form-control" name="tema" value={data.idTematik} onChange={(e) => this.temaOnChange(e)}>
                                                                    <option value="">Pilih Tematik...</option>
                                                                    { this.state.tematik.map((data,i) =>
                                                                        <option value={data.idTematik}>{data.namaTematik}</option>
                                                                    )}
                                                                </select>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col>
                                                            <Form.Group controlId="subTema">
                                                                <select className="form-control" name="subTema" value={data.idSubTematik} onChange={(e) => this.subTemaOnChange(e)}>
                                                                    <option value="">Pilih Sub Tematik...</option>
                                                                    { this.state.subTematik.map((data,i) =>
                                                                        <option value={data.idSubTematik}>{data.namaSubTematik}</option>
                                                                    )}
                                                                </select>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col>
                                                            <Form.Group controlId="pembTema">
                                                                <select className="form-control" name="pembTema" value={data.idPembTematik} onChange={(e) => this.pembTemaOnChange(e)}>
                                                                    <option value="">Pilih Pembelajaran Tematik...</option>
                                                                    { this.state.pembTematik.map((data,i) =>
                                                                        <option value={data.idPembTematik}>{data.namaPembTematik}</option>
                                                                    )}
                                                                </select>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </>
                                    </Form.Group>
                                </>
                            }

                            { this.state.filterSekolah &&
                                <Row>
                                    <Col sm={6}>
                                        <div className="form-group">
                                            <label htmlFor="upload">Upload History :</label>
                                            <select className="form-control" name="upload" id="upload">
                                                <option value="0">Pilih Upload History...</option>
                                                {this.renderUploadHis()}
                                            </select>
                                        </div>
                                    </Col>
                                    <input type="hidden" id="subbab" value="0" />
                                </Row>
                            }

                            <div>
                                <Button variant="outline-dark btn-lg" onClick={() => {this.btnTampil()} }>
                                    Tampilkan Soal
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Fade>
            : ''}
          </>
        );
    }

    removeSelected = (data) => {
        const { soalSelected, soals } = this.state;
        // console.info('sad', data);
        this.setState({
            soalSelected: soalSelected.filter(v => v.idBankSoal !== data),
            // soals: soals.find(item => item.idBankSoal == data)
        });
    }

    handleInput = (evt) => {
        const value = evt.target.value;
        this.setState({
            judulLearning: value
        });
    }

    renderSoal = () => {
        const { open, soals, soalSelected } = this.state;
        const scroll = {
            overflow: 'auto',
            maxHeight: '400px'
        };

        if(!open) {
            return (
                <Row style={{ marginTop: '10px' }}>
                    <Col sm={7} style={{ marginBottom: '30px' }}>
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a className="nav-link active" data-toggle="tab" href="#pilgan">Pilihan Ganda</a>
                            </li>
                            {/*
                            <li className="nav-item">
                                <a className="nav-link" data-toggle="tab" href="#essay">Essay</a>
                            </li>
                            */}
                            {/*
                            <li className="nav-item navbar-right">
                                <a className="nav-link" data-toggle="tab" href="#selected">Soal Terpilih : {soalSelected.length}</a>
                            </li>
                            */}
                        </ul>

                        <div className="tab-content">
                            <div className="tab-pane active" id="pilgan">
                                <table className="table">
                                    <tbody>
                                        { soals.map((soal,i) =>
                                            ( soal.tipeSoal === 'MULTIPLE' &&
                                                <tr key={soal.idBankSoal}>
                                                    <td>
                                                        <p>{i+1}.</p>
                                                    </td>
                                                    <td>
                                                        <div id="accordion">
                                                            <span dangerouslySetInnerHTML={{__html: soal.pertanyaan}}></span>
                                                            <span className="text-primary" data-toggle="collapse" href={'#soal' + soal.idBankSoal} aria-expanded="true" style={{ cursor: 'pointer'}}>details..</span>

                                                            <div id={'soal' + soal.idBankSoal} className="collapse" data-parent="#accordion">
                                                                <table className="table">
                                                                    <tbody>
                                                                        <tr style={{backgroundColor: soal.kunciJawaban === "1" ? "antiquewhite": ""}} >
                                                                            <td width="10px">
                                                                                <p>A.</p>
                                                                            </td>
                                                                            <td dangerouslySetInnerHTML={{__html: soal.jawab1}}></td>
                                                                        </tr>
                                                                        <tr style={{backgroundColor: soal.kunciJawaban === "2" ? "antiquewhite": ""}} >
                                                                            <td>
                                                                                <p>B.</p>
                                                                            </td>
                                                                            <td dangerouslySetInnerHTML={{__html: soal.jawab2}}></td>
                                                                        </tr>
                                                                        <tr style={{backgroundColor: soal.kunciJawaban === "3" ? "antiquewhite": ""}} >
                                                                            <td>
                                                                                <p>C.</p>
                                                                            </td>
                                                                            <td dangerouslySetInnerHTML={{__html: soal.jawab3}}></td>
                                                                        </tr>
                                                                        <tr style={{backgroundColor: soal.kunciJawaban === "4" ? "antiquewhite": ""}} >
                                                                            <td>
                                                                                <p>D.</p>
                                                                            </td>
                                                                            <td dangerouslySetInnerHTML={{__html: soal.jawab4}}></td>
                                                                        </tr>
                                                                        <tr style={{backgroundColor: soal.kunciJawaban === "5" ? "antiquewhite": ""}} >
                                                                            <td>
                                                                                <p>E.</p>
                                                                            </td>
                                                                            <td dangerouslySetInnerHTML={{__html: soal.jawab5}}></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <p>Pembahasan:</p>
                                                                                <span dangerouslySetInnerHTML={{__html: soal.isianJawaban}}></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <Switch value={soal.idBankSoal} onChange={e => this.handleChange(e)} defaultChecked={ soalSelected.find(val => val.idBankSoal === soal.idBankSoal ? true : false )} color="secondary"/>
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <div className="tab-pane" id="essay">
                                <h4>Fitur belum tersedia...</h4>
                            </div>
                        </div>
                    </Col>

                    <Col sm={5}>
                        <div style={{marginBottom: '5px'}}>
                            <input type="text" className="form-control" id="judul" maxLength="100" placeholder="Input Judul Learning..." onChange={this.handleInput} value={this.state.judulLearning} required/>
                        </div>
                        <div style={{ position: 'fixed' }}>
                            <Card >
                                <Card.Header>Soal Selected: {soalSelected.length}</Card.Header>

                                <div style={scroll}>
                                    <table className="table">
                                        <tbody id="cek">
                                            {soalSelected.map((sol, i) =>
                                                <tr key={sol.idBankSoal}>
                                                    <td>
                                                        <p>{i+1}.</p>
                                                    </td>
                                                    <td>
                                                        <span dangerouslySetInnerHTML={{__html: sol.pertanyaan}}></span>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Card>

                            <Col className="text-center" style={{ marginTop: '20px'}}>
                                { soalSelected.length > 0 &&
                                    <Button variant="primary" type="submit" style={{width:'100%'}} onClick={() =>  this.handleSubmit()}>
                                        Simpan <i className="fa fa-save"></i>
                                    </Button>
                                }
                            </Col>
                        </div>
                    </Col>
                </Row>
            )
        }
    }

    btnTampil = async(e) => {
        console.clear();
        console.time('SoalForm btnTampil time');

        this.setState({
            isFetching: true
        });
        let idSubBab = this.state.data.idSubBab;
        let idPembTematik = this.state.data.idPembTematik;

        console.groupCollapsed('Param btnTampil');
        console.info('idSubBab', this.state.filterPrime && idSubBab != null ? idSubBab : 0);
        console.info('idPembTematik', this.state.filterPrime && idPembTematik != null ? idPembTematik : 0);
        console.info('idUploadHis', this.state.filterSekolah ? document.getElementById('upload').value : 0);
        console.info('kodeOwner', document.getElementById('sumber').value);
        console.groupEnd();

        const result = await accountManagement.post(CONFIG.SOAL_FILTERSOAL, {...FilterSoal,
            ['idSubBab']: (this.state.filterPrime && idSubBab != null ? idSubBab : 0),
            ['idPembTematik']: (this.state.filterPrime && idPembTematik != null ? idPembTematik : 0),
            ['idUploadHis']: (this.state.filterSekolah ? document.getElementById('upload').value : 0),
            ['kodeOwner']: document.getElementById('sumber').value
        }).catch(function(error) {
            console.error('btnTampil', error);
        });

        if (result) {
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    soals: result.data.data
                });
            }
            else {
                this.setState({
                    resMessage: result.data.errorSchema
                })
            }
        }
        this.setState({
            isFetching: false,
            open: false
        });
        window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);
        console.timeEnd('SoalForm btnTampil time');
    }

    handleChange(e) {
        console.clear();
        console.timeEnd('SoalForm handleChange time');

        let isChecked = e.target.checked;
        let value = e.target.value;
        const { soals, soalSelected } = this.state;

        console.groupCollapsed('handleChange Cek');
        console.info('isChecked', isChecked);
        console.info('value', value);
        console.info('soals', soals);
        console.info('soalSelected', soalSelected);
        console.groupEnd();

        // do whatever you want with isChecked value
        if(isChecked) {
            soals.map(soal => {
                console.info('isChecked', soal.idBankSoal === parseInt(value));
                if (soal.idBankSoal === parseInt(value)) {
                    this.setState(prevState => ({
                        soalSelected: [...prevState.soalSelected,
                            soal
                        ]
                    }));
                }
            })
        }
        else {
            this.setState({
                soalSelected: soalSelected.filter(v => v.idBankSoal !== parseInt(value))
            });
        }
        window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub, ""]);
        console.timeEnd('SoalForm handleChange time');
    }

    changeSumber = (e) => {
        console.clear();
        console.time('SoalForm changeSumber time');
        let value = e.target.value;

        console.groupCollapsed('changeSumber');
        console.info('value', value);
        console.info('idKelas', this.state.data.idKelas);
        console.groupEnd();
        if(value === 'PRIME') {
            this.setState({
                filterPrime: true,
                filterSekolah: false
            })

            if(this.props.data !== null) {
                /*
                this.getRencBelKelasParalel(this.props.data.idRencana);
                this.getKelasParalel(this.state.data.idKelas);
                */
                this.getMapel(this.state.data.idKelas, this.state.data.idGuru);
                this.getBab(this.state.data.idMapel);
                this.getSubBab(this.state.data.idBab);

                this.getTematik(this.state.data.idKelas);
            }
        }
        else {
            this.setState({
                filterPrime: false,
                filterSekolah: true
            })
        }
        console.timeEnd('SoalForm changeSumber time');
    }

    handleSubmit = async() => {
        const {soalSelected,judulLearning} = this.state;
        if(judulLearning === '') {
            this.setState({ alertShow: true, resMessage: 'Silahkan Input Judul Soal Learning... !! '})
            document.getElementById("judul").focus();
            return false;
        }

        if (window.confirm('Konfirmasi Simpan ?')) {
            this.setState({isFetching: true});
            let {data, action} = this.state;

            if(data.owner === 'PRIME') {
                action = 'add';
            }

            if(action === 'add') {
                const response = await accountManagement.post(CONFIG.LEARNING_POST_PEMB_LATIHAN, {...LearningContentReq,
                    ["idKelas"]: data.idKelas,
                    ["idMapel"]: data.idMapel,
                    ["idBab"]: data.idBab,
                    ["idSubBab"]: data.idSubBab,
                    ["idTematik"]: data.idTematik,
                    ["idSubTematik"]: data.idSubTematik,
                    ["idPembTematik"]: data.idPembTematik,
                    ["idRencana"]: data.idRencana,
                    ["owner"]: 'GURU',
                    ["tipeKontent"]: 'SOAL',
                    ["soal_list"]: soalSelected.map(val => val.idBankSoal),
                    ["judul"]: this.state.judulLearning
                }).catch(function(error) {
                    console.error(error);
                });

                if(response) {
                    if(response.data.code === '200') {
                        history.push({
                            pathname: '/learning_konten/SOAL/',
                            state: this.state.data
                        })
                    }
                    else {
                        this.setState({
                            alertShow: true,
                            resMessage: response.data.msg
                        })
                    }
                    this.setState({
                        isFetching: false
                    });
                }
            }
            else if(action === 'edit') {
                const response = await accountManagement.post(CONFIG.LEARNING_POST_EDIT_PEMB_LATIHAN, {LearningContentReq,
                    ["idProfilePemLat"]: data.idProfil,
                    ["idKelas"]: data.idKelas,
                    ["idMapel"]: data.idMapel,
                    ["idBab"]: data.idBab,
                    ["idSubBab"]: data.idSubBab,
                    ["idTematik"]: data.idTematik,
                    ["idSubTematik"]: data.idSubTematik,
                    ["idPembTematik"]: data.idPembTematik,
                    ["idRencana"]: data.idRencana,
                    ["tipeKontent"]: 'SOAL',
                    ["soal_list"]: soalSelected.map(val => val.idBankSoal),
                    ["judul"]: this.state.judulLearning
                }).catch(function(error) {
                    console.error(error);
                });

                if(response) {
                    if(response.data.code === '200') {
                        history.push({
                            pathname: '/learning_konten/SOAL/',
                            state: this.state.data
                        })
                    }
                    else {
                        this.setState({
                            alertShow: true,
                            resMessage: response.data.msg
                        })
                    }
                    this.setState({
                        isFetching: false
                    });
                }
            }
        }
    }

    handleBack = () => {
        console.info('State Data', this.state.data);
        history.push({
            pathname: '/learning_konten/SOAL/',
            state: this.state.data
        })
    }

    render() {
        console.groupCollapsed('This Render SoalForm Cek State/Props');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.info('Props Data Prev', this.props.location.state);
        console.groupEnd();

        return (
            <>
                <Container fluid style={{ marginTop: '20px' }}>
                    <LoaderModal isFetching={this.state.isFetching}/>
                    {this.loadAlert()}
                    {this.loading()}
                    {this.filterSoal()}
                    {this.renderSoal()}
                </Container>
            </>
        );
    }

    loadAlert = () => {
        const { alertShow } = this.state;

        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        }
    }

    loading = () => {
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }
}

export default SoalForm;